import http from '@root/utils/axios/admin';

let state = {
    CurrenciesList: [],
    Currency: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchCurrenciesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/api/currencies', { params: filter }).then((response) => {
                commit('setCurrencies', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteCurrency({ commit }, id) {
        return http.delete('/api/currencies/' + id);
    },

    fetchCurrency({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/api/currencies/' + id).then((response) => {
                commit('setCurrency', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateCurrency({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/currencies', data).then((response) => {
                commit('setCurrency', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCurrencyError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateCurrency({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/currencies/' + data.id, data).then((response) => {
                commit('setCurrency', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCurrencyError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setCurrencies(state, data) {
        state.CurrenciesList = data;
    },
    setCurrency(state, data) {
        state.Currency.data = data;
    },
    setCurrencyError(state, error) {

        state.Currency.error = error.errors;
    },
    cleanCurrencyError(state, error) {
        state.Currency.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}